"use client";

import { c as _c } from "react/compiler-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { Label } from "@/components/ui";
import { SearchSelect, SearchSelectContent, SearchSelectItem, SearchSelectTrigger, SearchSelectValue } from "@/components/ui/select";
import { useLocations } from "@/hooks/use-locations";
import { cx } from "@/lib/tailwind-utils";

/**
 * Primary-location picker shared by Create Patient and demographics edit.
 * Hidden when the tenant has zero or one location.
 */
export default function LocationField(t0) {
  const $ = _c(18);
  const {
    required: t1,
    className
  } = t0;
  const required = t1 === undefined ? false : t1;
  const {
    locations
  } = useLocations();
  const {
    control,
    formState: t2
  } = useFormContext();
  const {
    errors
  } = t2;
  if (locations.length <= 1) {
    return null;
  }
  let t3;
  if ($[0] !== locations) {
    t3 = locations.map(_temp);
    $[0] = locations;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const locationOptions = t3;
  const errorMessage = errors.primaryLocationId?.message as string | undefined;
  let t4;
  if ($[2] !== className) {
    t4 = cx(className);
    $[2] = className;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== required) {
    t5 = <Label htmlFor="primaryLocationId" mandatory={required}>Primary Location</Label>;
    $[4] = required;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== locationOptions) {
    t6 = t7 => {
      const {
        field
      } = t7;
      const selectedOption = locationOptions.find(opt => opt.value === field.value);
      return <SearchSelect value={field.value || ""} onValueChange={field.onChange}><SearchSelectTrigger className="mt-1 w-full"><SearchSelectValue placeholder="Select a location" formatValue={value => selectedOption?.label || value} /></SearchSelectTrigger><SearchSelectContent searchPlaceholder="Search location..." emptyMessage="No location found.">{locationOptions.map(_temp2)}</SearchSelectContent></SearchSelect>;
    };
    $[6] = locationOptions;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== control || $[9] !== t6) {
    t7 = <Controller name="primaryLocationId" control={control} render={t6} />;
    $[8] = control;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== errorMessage) {
    t8 = errorMessage && <p className="mt-1 text-caption text-status-error-text">{errorMessage}</p>;
    $[11] = errorMessage;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t7 || $[16] !== t8) {
    t9 = <div className={t4}>{t5}{t7}{t8}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp2(option) {
  return <SearchSelectItem key={option.value} value={option.value}>{option.label}</SearchSelectItem>;
}
function _temp(location) {
  return {
    value: location.id,
    label: location.name
  };
}